// extracted by mini-css-extract-plugin
export default {"container":"Kq-z","heading":"Lq-z","text":"Mq-z","info":"Nq-z","link":"Oq-z","fullMaxWidth":"Pq-z"};